export class SearchAllPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sections",
            "baseName": "sections",
            "type": "Array<SearchAllSectionRef>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllPlan.attributeTypeMap;
    }
    constructor() {
    }
}
